import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { Button, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import NoData from "../../assets/noAssets.png";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import IOSSwitch from "../../components/SwitchButton";
import moment from "moment";
import LoupeOutlinedIcon from "@mui/icons-material/LoupeOutlined";
import { requestUpdateUserStatus } from "../../redux/actions/tabManagementActionCreators";
import { useDispatch } from "react-redux";


export default function SimpleAccordion({
  rows,
  head,
  handeleUserDetails,
  page,
  handlePage,
  totalPages,
  searchText,
  enterprise,
  status,
  type,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getAccountTypeLabel = (accountType) => {
    if (accountType === "enterprise") {
      return "Enterprise";
    }
    if (accountType === "free") {
      return "Free";
    }
    return t(accountType);
  };


  return (
    <div>
      {rows?.map((el) => (
        <>
          <div>
            <Accordion key={el?.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                  backgroundColor: "#F3FBF9",
                  borderBottom: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: 1,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  color: "#494949",

                  "& .MuiTypography-root": {
                    margin: 0,
                    fontSize: "12px",
                    fontWeight: 900,
                    fontFamily:
                      "Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
                    lineHeight: 1.3,
                    letterSpacing: "0.00938em",
                    "& .MuiPaper-root": { boxShadow: "none" },
                  },
                }}
              >
                <div>
                  <Typography>
                    {t("username")} : {el?.username}{" "}
                  </Typography>
                  <br />
                  <Typography>
                    {t("email_address")} : {el?.email}{" "}
                  </Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  backgroundColor: "#FFFFFF",
                  borderBottom: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: 1,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  color: "#121828",

                  "& .MuiTypography-root": {
                    margin: 0,
                    fontSize: "12px",
                    fontWeight: 800,
                    fontFamily:
                      "Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
                    lineHeight: 1.5,
                    letterSpacing: "0.00938em",
                    "& .MuiPaper-root": { boxShadow: "none" },
                  },
                }}
              >
                <Typography>
                  <>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 2px",
                        flexWrap: "wrap",
                      }}
                    >
                      <span style={{ color: "rgb(71 138 119)" }}>
                        {t("account_type")}
                      </span>

                      <span>{getAccountTypeLabel(el?.type)}</span>
                    </span>
                    <hr style={{ borderColor: "#B1B4BC5C" }} />
                    <span
                      style={{
                        padding: "5px 2px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ color: "rgb(71 138 119)" }}>
                          {t("creation_date")}
                        </span>
                        <span>
                          {moment(
                            el?.creation_date,
                            "DD/MM/YYYY HH:mm:ss"
                          ).format("DD-MM-YYYY")}
                        </span>
                      </div>
                    </span>
                    <hr style={{ borderColor: "#B1B4BC5C" }} />
                    {el?.type === "enterprise" && (
                      <>
                        <span
                          style={{
                            padding: "5px 2px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <span style={{ color: "rgb(71 138 119)" }}>
                              {t("action")}
                            </span>
                            <span>
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    sx={{ margin: "8px -8px 4px 8px" }}
                                    color="success"
                                    checked={el?.status}
                          onChange={(event) => {
                            dispatch(
                              requestUpdateUserStatus(
                                page,
                                searchText,
                                enterprise,
                                status,
                                type,
                                el?.public_id,
                                event.target.checked
                              )
                            );
                          }}
                                  />
                                }
                              />
                            </span>
                          </div>
                        </span>
                        <hr style={{ borderColor: "#B1B4BC5C" }} />
                      </>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "5px 2px",
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          height: "40px",
                          width: "100%",
                          m: "5px 5px",
                          display: "flex",
                          gap: "3px",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          handeleUserDetails(el);
                        }}
                      >
                        <LoupeOutlinedIcon /> {t("Details")}
                      </Button>
                    </div>
                  </>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <br />
          </div>
          {rows.length === 0 && (
            <Grid container sx={{ textAlign: "center", mt: "100px" }}>
              <Grid item xs={12}>
                <Typography variant="title">No Data Found</Typography>
              </Grid>
              <Grid item xs={12}>
                <img src={NoData} alt="No Data" />
              </Grid>
            </Grid>
          )}
        </>
      ))}
      <Stack spacing={2} justifyContent="center" direction="row">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, p) => handlePage(p)}
          variant="outlined"
          shape="rounded"
          color="secondary"
        />
      </Stack>
    </div>
  );
}
